var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBubbleArrowUp16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.657 1.099c1.201-1.465 3.485-1.465 4.686 0L16 8H0l5.657-6.901z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.92 7.024L9.561 1.708a2.031 2.031 0 00-3.124 0L2.081 7.024h11.838zM10.342 1.1c-1.201-1.465-3.485-1.465-4.686 0L0 8h16l-5.657-6.901z",
    fill: "#CED4DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.081 7.024H13.92l.783.976H1.2l.881-.976z",
    fill: "#fff"
  })));
}

export default SvgBubbleArrowUp16;